/**
 * LoggingMiddleware
 *
 * The LoggingMiddleware logs each incoming action to the console.
 *
 * @module middleware/Logging
 */
import { AudioPlayerActions } from '../constants/AudioPlayer';
import { shouldLogActionsToConsole } from '../lib/configuration/DebugSettingsUtil';
import Logger from '../tools/Logger';

const log = Logger.child({ component: 'middleware/Logging' });

function getActionDataString(action) {
  let data = action.data || {};
  if (data.password) {
    data = Object.assign({}, data, { password: '---' });
  }
  try {
    return JSON.stringify(data);
  } catch (err) {
    log.error(err, 'Unable to stringify JSON');
  }
}

/**
 * Pass incoming actions to ActionRouter
 *
 * @param  {object} store - redux
 * @param  {object} next - dispatch function of next middleware in the chain
 * @param  {object} action - the current action
 * @returns {Promise} resolution of the workflow
 */
export default (/* store*/) => next => action => {
  if (shouldLogActionsToConsole() && action.type && action.type !== AudioPlayerActions.UPDATE) {
    log.trace(`dispatching action ${action.type}: `, getActionDataString(action));
  }
  return next(action);
};
